'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdGrain = function MdGrain(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.6 6.6c1.8 0 3.4 1.6 3.4 3.4s-1.6 3.4-3.4 3.4-3.2-1.6-3.2-3.4 1.4-3.4 3.2-3.4z m6.8 6.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.4-3.2 3.4-3.4-1.6-3.4-3.4 1.6-3.2 3.4-3.2z m6.6 6.6c1.8 0 3.4 1.6 3.4 3.4s-1.6 3.2-3.4 3.2-3.4-1.4-3.4-3.2 1.6-3.4 3.4-3.4z m-6.6 6.6c1.8 0 3.2 1.6 3.2 3.4s-1.4 3.4-3.2 3.4-3.4-1.6-3.4-3.4 1.6-3.4 3.4-3.4z m6.6-13.2c-1.8 0-3.4-1.6-3.4-3.4s1.6-3.4 3.4-3.4 3.4 1.6 3.4 3.4-1.6 3.4-3.4 3.4z m-20 13.2c1.8 0 3.4 1.6 3.4 3.4s-1.6 3.4-3.4 3.4-3.4-1.6-3.4-3.4 1.6-3.4 3.4-3.4z m0-13.2c1.8 0 3.4 1.4 3.4 3.2s-1.6 3.4-3.4 3.4-3.4-1.6-3.4-3.4 1.6-3.2 3.4-3.2z m6.6 6.6c1.8 0 3.4 1.6 3.4 3.4s-1.6 3.2-3.4 3.2-3.2-1.4-3.2-3.2 1.4-3.4 3.2-3.4z' })
        )
    );
};

exports.default = MdGrain;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/grain.js
// module id = 1588
// module chunks = 168707334958949